// @flow

export const setAuthMsg = (message: string = '', msgType: string = '', msgRaw: bool = false, msgFloat: bool = false, msgProvider: string = 'email', failed_attempts: number = 0) => {
  return { type: 'SET_AUTH_MSG', message, msgType, msgRaw, msgFloat, msgProvider, failed_attempts };
}

export const clearAuthMsg = () => {
  return { type: 'CLEAR_AUTH_MSG' };
}



// WEBPACK FOOTER //
// ./src/actions/session/authMsg.js